import './../../style/multChoice.css';
import { useContext, useEffect, useState } from 'react';
import CheckBox from "./checkBox"

function MCQuiz({question, answers, correctAnswers, correctMsg, wrongMsg, height}) {
    const [buttonsData, setButtonsData] = useState([])
    const [finished, setFinished] = useState(false)
    const [flip, setFlip] = useState(false)
    const [currentAnswer, setCurrentAnswer] = useState("")
    const [checkDisabled, setCheckDisabled] = useState(true)
    

    useEffect(() => {
        const initialButtonsData = answers.map((answer, index) => {
            console.log(index)
            return {
                labelText: answer, 
                isChecked: false,
                isCorrect: correctAnswers.includes(index)
            }
        })
        setButtonsData(initialButtonsData)
    }, [])


    useEffect(() => {
        const correctlyCheckedAnsers = buttonsData.filter(element => element.isChecked && element.isCorrect)
        const incorrectlyCheckedAnsers = buttonsData.filter(element => element.isChecked && !element.isCorrect)
        console.log(correctlyCheckedAnsers)
        correctlyCheckedAnsers.length === correctAnswers.length && incorrectlyCheckedAnsers.length === 0 ? setFinished(true) : setFinished(false)       
    }, [buttonsData])



    const buttonChecked = (labelOfCheckedBtn) => {
        console.log("Checked: ", labelOfCheckedBtn)
        const updatedButtonsData = buttonsData.map(element => {

            return {
                ...element, 
                isChecked: element.labelText === labelOfCheckedBtn ? !element.isChecked : element.isChecked
            }
        })
    //    setCurrentAnswer(labelOfCheckedBtn)
        setButtonsData(updatedButtonsData)
        setCheckDisabled(false)
    }

    const toggleFlip = () => {
        setFlip(oldFlip => !oldFlip)
    }



    return (
        <div className='container example-container'>

            <div className='card card-mc '>
                <div className='card-body'>
                    <div className='flip-card ' style={{height: height + "px"}}>
                        <div className={"flip-card-inner " + (flip === true ? "flip" : "")}>
                            <div className='flip-card-front'> 
                                <h5 className="card-title "
                                                dangerouslySetInnerHTML={{__html: question}}
                                            /> 

                                    <div>
                                        <div className='radioButtonsContainer'>
                                        {
                                            buttonsData.map(element => {
                                                return <CheckBox key={element.labelText} id={element.labelText} 
                                                    labelText={ element.labelText} 
                                                    isChecked={element.isChecked} buttonChecked={buttonChecked} 
                                                    />
                                            })
                                        }
                                        </div>
                                        <div>
                                            <button className="btn btn-primary mt-3" onClick={toggleFlip} disabled={checkDisabled}>Check</button>
                                        </div>
                                    </div>
                            </div>


                            <div className='flip-card-back'> 
                                {
                                    finished ?
                                    <div className='result-correct'>
                                        <div className='resultMsg'>
                                            <p className="pl-1 pr-1 "
                                                dangerouslySetInnerHTML={{__html: correctMsg}}
                                            />  
                                        </div>
                                        <button className="btn btn-primary " onClick={toggleFlip}>Nochmal</button>
                                    </div>
                                    :
                                    <div className='result-wrong'>
                                        <div className='resultMsg'>
                                        <p className="pl-1 pr-1 "
                                                dangerouslySetInnerHTML={{__html: wrongMsg}}
                                            />  
                                        </div>
                                        <button className="btn btn-primary " onClick={toggleFlip}>Nochmal</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MCQuiz